export default __webpack_public_path__ + "static/media/smallMockup16.ed384760.jpg";